import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02164af7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "heading-subtitle mt-3 mb-3"
}
const _hoisted_3 = {
  key: 2,
  class: "heading-subtitle mt-3 mb-3"
}
const _hoisted_4 = {
  key: 3,
  class: "payment-ach"
}
const _hoisted_5 = {
  key: 4,
  class: "payment-check"
}
const _hoisted_6 = {
  key: 5,
  class: "application-notes check"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Make all checks payable to P&A Administrative Services, Inc.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Write the Confirmation Number on your check.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode(" Payments are to be sent to:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", { class: "payment-address" }, [
    /*#__PURE__*/_createTextVNode(" P&A Administrative Services, Inc."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Department 383"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" P.O. Box 8000"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Buffalo, NY 14267 ")
  ])
], -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 6,
  class: "payment-check"
}
const _hoisted_12 = { class: "application-notes" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Please be advised your coverage will not be effective with the insurance carrier(s) until payment is received by P&A Group. ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Please be advised it may take 2-7 business days for your coverage to be reflected with the carrier(s). ", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.validationMsg)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "alert alert-danger",
          innerHTML: _ctx.validationMsg
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (!_ctx.appSubmitted)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_2, " Thank you for submitting your elections to P&A Group! "))
      : (_openBlock(), _createElementBlock("h5", _hoisted_3, " You submitted your elections to P&A Group on " + _toDisplayString(_ctx.getEnrollmentDate()), 1)),
    _createElementVNode("p", null, [
      _createElementVNode("b", null, "Your confirmation number is " + _toDisplayString(_ctx.profileData.electionId), 1)
    ]),
    _createElementVNode("p", null, [
      _createTextVNode(" To save a copy of the enrollment confirmation, please download your confirmation "),
      _createElementVNode("a", {
        class: "a confirmation-download-link",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadAsPDF && _ctx.downloadAsPDF(...args)))
      }, "here")
    ]),
    (_ctx.paymentType === _ctx.paymentMethod.ACH)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " The amount due today will be deducted from your bank account within 1-3 business days. "))
      : _createCommentVNode("", true),
    (_ctx.paymentType === _ctx.paymentMethod.Invoice)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, " If you have not sent a check for your initial payment, PLEASE REMEMBER TO: "))
      : _createCommentVNode("", true),
    (_ctx.paymentType === _ctx.paymentMethod.Invoice)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_6, _hoisted_10))
      : _createCommentVNode("", true),
    (
      _ctx.isStripeEnabled &&
      _ctx.paymentType === _ctx.paymentMethod.Card &&
      _ctx.cardDetail.cardType
    )
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Your amount due today is processed using your " + _toDisplayString(_ctx.cardDetail.cardType) + " card. ", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _hoisted_14,
      (_ctx.specialOpenEnrollmentCreated)
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
            _createTextVNode(" You have an open enrollment. Click "),
            _createElementVNode("a", {
              id: "specialEnrollmentLink",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startSpecialEnrollment && _ctx.startSpecialEnrollment(...args)))
            }, "here"),
            _createTextVNode(" to proceed with the open enrollment elections. ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, [
        _createTextVNode(" If you have any questions about your rights to COBRA continuation coverage, please contact P&A Group’s Participant Support Center at (716) 852-2611 or through online webchat at "),
        _createElementVNode("a", {
          href: _ctx.links.contactUs,
          target: "_blank"
        }, _toDisplayString(_ctx.links.contactUs), 9, _hoisted_16),
        _createTextVNode(", Monday – Friday, 8:30 a.m. – 10:00 p.m. ET ")
      ])
    ])
  ], 64))
}